import React, {useEffect, useState} from "react";
import MaterialController from "./MaterialController";
import {useSnapshot} from "valtio";
import {state, configuratorState} from "../../state";
import {getUniqueListBy} from "../utils/Utils";

const MaterialInitialiser = ({geometries}) => {
  
  const {materialsLocation, materialCategoryLocation} = useSnapshot(state);
  const {
    selectedMaterialGroup,
    partSelected,
    activeMaterialData,
    modelToMaterials,
    materialMenusReference
  } = useSnapshot(configuratorState);
  
  const [activeMaterials] = useState([]);
  
  const texturePath = materialsLocation + materialCategoryLocation;
  
  // on init
  
  useEffect(() => {
    
    const modelMaterials = [];
    
    // from meshes extract applied materials
    geometries.forEach((geom) => {
      modelMaterials.push(geom.material);
    });
    
    const availableMats = getUniqueListBy(modelMaterials, 'name');
    
    Object.keys(modelToMaterials).forEach((prop) => {
      
      const materialObj = {}
      const matRef = materialMenusReference.find(set => set.title === prop);
      
      const mats = [];
      modelToMaterials[prop].forEach((item) => {
        mats.push(availableMats.find(mat => mat.name === item));
      })
      
      materialObj['name'] = prop;
      materialObj['mats'] = mats;
      
      activeMaterials.push(materialObj);
      
      const matCat = matRef['menu'][0];
      const activeMaterialData = matRef['menu'][0].menu[0];
      
      const newTextureSet = activeMaterialData['textureSet'];
      const newMaterialProps = activeMaterialData['materialProps'];
      
      MaterialController(materialObj, newTextureSet, newMaterialProps, texturePath + matCat.title + '/');
  
    });
    
    
  }, [geometries]);
  
  // on select new material
  
  useEffect(() => {
    
    if (!activeMaterialData) return;
    
    const newTextureSet = activeMaterialData['textureSet'];
    const newMaterialProps = activeMaterialData['materialProps'];
    
    const materials = activeMaterials.find(mat => mat.name === partSelected);
    
    MaterialController(materials, newTextureSet, newMaterialProps, texturePath + selectedMaterialGroup + '/');
    
  });
}

export default MaterialInitialiser;
